import React from 'react'
import Img from 'gatsby-image'
import EndorsementForm from '../components/EndorsementForm'

const PartnerSection = props => {
  const partners = [
    {
      name: 'Meals on Wheels',
      resolutions: props.mealsOnWheelsImage.resolutions,
      href: 'https://www.mealsonwheelscentraltexas.org/',
    },
    {
      name: 'Affordable Central Texas',
      resolutions: props.affordableCTXImage.resolutions,
      href: 'https://affordablectx.org/',
    },
    {
      name: 'Austin Housing Coalition',
      resolutions: props.austinHousingCoalitionImage.resolutions,
      href: 'http://austinhousingcoalition.org/',
    },
    {
      name: 'Habitat For Humanity',
      resolutions: props.habitatForHumanityImage.resolutions,
      href: 'https://www.austinhabitat.org/',
    },
    {
      name: 'Foundation Communities',
      resolutions: props.foundationCommunitiesImage.resolutions,
      href: 'https://foundcom.org/',
    },
    {
      name: 'SAFE Alliance',
      resolutions: props.safeImage.resolutions,
      href: ' http://www.safeaustin.org/',
    },
    {
      name: 'Austin Board of Realtors',
      resolutions: props.aborImage.resolutions,
      href: 'https://www.abor.com/',
    },
    {
      name: 'Housing Works',
      resolutions: props.housingWorksAustinImage.resolutions,
      href: 'http://housingworksaustin.org/',
    },
    {
      name: 'Austin Urban League',
      resolutions: props.austinUrbanLeagueImage.resolutions,
      href: 'http://aaul.org/',
    },
    {
      name: 'Easterseals',
      resolutions: props.easterSealsImage.resolutions,
      href: 'http://www.easterseals.com/centraltx/',
    },
    {
      name: 'Caritas of Austin',
      resolutions: props.caritasImage.resolutions,
      href: 'https://www.caritasofaustin.org/',
    },
    {
      name: 'DMA Company',
      resolutions: props.dmaImage.resolutions,
      href: 'https://dmacompanies.com/',
    },
    {
      name: 'ECHO',
      resolutions: props.echoImage.resolutions,
      href: 'http://www.austinecho.org/',
    },
    {
      name: 'LifeWorks',
      resolutions: props.lifeworksImage.resolutions,
      href: 'http://www.lifeworksaustin.org/',
    },
    {
      name: 'Austin Community Design and Development Center',
      resolutions: props.austinCommunityDesignCenterImage.resolutions,
      href: 'https://acddc.org',
    },
    {
      name: 'Guadalupe Neighborhood Development Corporation (GNDC)',
      resolutions: props.gndcImage.resolutions,
      href: 'http://www.guadalupendc.org/',
    },
  ]

  return (
    <div className="container py-4">
      <div className="row">
        <div className="col">
          <h2 className="mb-4" style={{ fontWeight: 'bold' }}>
            Our Coalition
          </h2>
        </div>
      </div>
      <div
        className="row align-items-center justify-content-center"
        style={{ textAlign: 'center' }}
      >
        {partners.map((partner, i) => (
          <div className="col-sm hover01" key={i}>
            <a href={partner.href} target="_blank">
              <figure>
                <Img
                  title={partner.name}
                  alt={partner.name}
                  resolutions={partner.resolutions}
                />
              </figure>
            </a>
          </div>
        ))}
      </div>
      {/* <div className="row justify-content-center">
        <div className="col-12 col-sm-8">
          <h2 className="mb-4">
            Does your organization want to endorse or receive a presentation
            about the 2018 Affordable Housing Bond?
          </h2>
          <EndorsementForm />
        </div>
      </div> */}
    </div>
  )
}

export default PartnerSection



// WEBPACK FOOTER //
// ./src/components/PartnersSection.js